import React from 'react';

import { Button, Layout, Modal, Breadcrumb, Steps } from 'antd/lib';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getDepositosPorRangoFecha from '../../../graphql/querys/ventas/getDepositosPorRangoFecha.graphql';
import getVentasSQL from '../../../graphql/querys/ventas/getVentasSQL.graphql';
import getIngresosPorRangoFecha from '../../../graphql/querys/ventas/getIngresosPorRangoFecha.graphql';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import FormRangoFechas from '../reportes/FormRangoFechas';
import TablaMostrarDepositos from '../reportes/TablaMostrarDepositos';
import TablaReporteVentas from '../reportes/TablaMostrarReporte';

import insertRendicion from '../../../graphql/mutations/venta/insertRendicion.graphql';
import { imprimirReporteRendicion } from '../../common/impresion/ImprimirReporteRendicion';

const confirm = Modal.confirm;

@compose(
  graphql(getUsuario),
  graphql(insertRendicion, {
    name: 'insertRendicion',
  })
)
class ReporteRendicion extends React.Component {
  state = {
    tipo_sellos: [],
    ventas_efectivo: [],
    ventas_posnet: [],
    detalle_posnet: [],
    envios: [],
    fechaInicio: '',
    fechaFin: '',
    terminado: false,
    step: 0,
  };

  onSubmit = e => {
    e.preventDefault();
    // console.log(e);
    this.buscar();
  };

  buscar = (fechaInicio, fechaFin, idOrganismo, nombreOrganismo) => {
    // console.log("Buscando....");
    // console.log(fechaInicio);
    // console.log(fechaFin);
    // console.log(idOrganismo);

    //Buscamos las ventas
    this.props.client
      .query({
        query: getVentasSQL,
        variables: {
          fechaInicio: moment(fechaInicio)
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .toDate(),
          fechaFin: moment(fechaFin)
            .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
            .toDate(),
          idOrganismo,
        },
      })
      .then(respuesta => {
        let colVentas = respuesta.data.getVentasSQL;
        let ventas = [];
        let ventasPosnet = [];
        _.map(colVentas, venta => {
          if (venta.pago.datosPosnet) {
            this.actualizarTiposSellosPosnet(venta);
            let ventasPosnet = this.state.ventas_posnet;
            ventasPosnet.push(venta);
          } else {
            this.actualizarTiposSellos(venta);
            ventas = this.state.ventas_efectivo;
            ventas.push(venta);
          }
          //Una vez que tenemos todos los datos, mostramos la tabla.
          this.setState({
            ...this.state,
            idOrganismo,
            nombreOrganismo,
            fechaInicio,
            fechaFin,
            ventas_posnet: ventasPosnet,
            ventas_efectivo: ventas,

            fechaGeneracion: new Date(),
            ventas: colVentas,
            step: 1,
          });
        });
      })
      .catch(error => {
        console.log('Error a la hora de buscar las ventas SQL: ', error);
      });

    //Buscamos los Ingresos/Envios en el rango de fechas
    this.props.client
      .query({
        query: getIngresosPorRangoFecha,
        variables: { fechaInicio, fechaFin, idOrganismo },
      })
      .then(res => {
        let colIngresos = res.data.getIngresosPorRangoFecha;
        _.map(colIngresos, ingreso => this.formarEnvios(ingreso));

        //Una vez que tenemos todos los datos, mostramos la tabla.
        this.setState({
          ...this.state,
          ingresos: colIngresos,
          idOrganismo,
          nombreOrganismo,
          fechaInicio,
          fechaFin,
          step: 1,
        });
      })
      .catch(err => {
        console.log('Error en la busqueda de ingresos.');
        console.log(err);
      });

    //Buscamos los depositos por el rango de fechas.
    this.props.client
      .query({
        query: getDepositosPorRangoFecha,
        variables: { fechaInicio, fechaFin, idOrganismo },
      })
      .then(res => {
        let colDepositos = res.data.getDepositosPorRangoFecha;

        let depositos = _.map(colDepositos, deposito => {
          return {
            ...deposito,
            key: deposito._id,
            fecha: moment(deposito.fecha).format('DD/MM/YYYY'),
          };
        });

        //Una vez que tenemos todos los datos, mostramos la tabla.
        this.setState({
          ...this.state,
          depositos: depositos,
          step: 1,
        });
      })
      .catch(err => {
        console.log('Error en la busqueda de depositos.');
        console.log(err);
      });
  };

  actualizarTiposSellos = venta => {
    //Esta funcion, recorre los detalle de una venta
    // Y actualiza el estado interno de componente, dependiendo los sellos del detalle.

    try {
      _.map(venta.detalles, detalle => {
        let nuevosTipo_sellos = this.state.tipo_sellos;
        let nuevoDetalle = {
          idTipo_Sello: detalle.tipo_sello._id,
          nombre: detalle.tipo_sello.nombre,
          valor: detalle.tipo_sello.valor,
          cantidad: detalle.cantidad,
        };
        nuevosTipo_sellos.push(nuevoDetalle);

        var output = _(nuevosTipo_sellos)
          .groupBy('idTipo_Sello')
          .map((objs, key) => ({
            key: key,
            idTipo_Sello: key,
            nombre: objs[0].nombre,
            valor: objs[0].valor,
            cantidad: _.sumBy(objs, 'cantidad'),
            subtotal: objs[0].valor * _.sumBy(objs, 'cantidad'),
          }))
          .value();

        this.setState({
          ...this.state,
          tipo_sellos: output,
          terminado: true,
        });
      });
    } catch (err) {
      Modal.error({
        title: 'Error en el calculo de los items de ventas',
        content:
          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
      });
      console.log(err);
    }
  };

  actualizarTiposSellosPosnet = venta => {
    //Esta funcion, recorre los detalle de una venta
    // Y actualiza el estado interno de componente, dependiendo los sellos del detalle.

    try {
      _.map(venta.detalles, detalle => {
        // console.log('DETALLE: ', detalle);
        let nuevosTipo_sellos = this.state.detalle_posnet;
        let nuevoDetalle = {
          idTipo_Sello: detalle.tipo_sello._id,
          nombre: detalle.tipo_sello.nombre,
          valor: detalle.tipo_sello.valor,
          cantidad: detalle.cantidad,
        };
        nuevosTipo_sellos.push(nuevoDetalle);

        var output = _(nuevosTipo_sellos)
          .groupBy('idTipo_Sello')
          .map((objs, key) => ({
            key: key,
            idTipo_Sello: key,
            nombre: objs[0].nombre,
            valor: objs[0].valor,
            cantidad: _.sumBy(objs, 'cantidad'),
            subtotal: objs[0].valor * _.sumBy(objs, 'cantidad'),
          }))
          .value();

        this.setState({
          ...this.state,
          detalle_posnet: output,
        });
      });
    } catch (err) {
      Modal.error({
        title: 'Error en el calculo de los items de ventas',
        content:
          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
      });
      console.log(err);
    }
  };

  formarEnvios = envio => {
    //Esta funcion, recorre los detalle de una venta
    // Y actualiza el estado interno de componente, dependiendo los sellos del detalle.

    try {
      _.map(envio.detalle, detalle => {
        let nuevosTipo_sellos = this.state.envios;
        let nuevoDetalle = {
          idTipo_Sello: detalle.tipo_sello._id,
          nombre: detalle.tipo_sello.nombre,
          valor: detalle.tipo_sello.valor,
          cantidad: detalle.cantidad,
        };
        nuevosTipo_sellos.push(nuevoDetalle);

        var output = _(nuevosTipo_sellos)
          .groupBy('idTipo_Sello')
          .map((objs, key) => ({
            _id: key,
            idTipo_Sello: key,
            nombre: objs[0].nombre,
            valor: objs[0].valor,
            cantidad: _.sumBy(objs, 'cantidad'),
            subtotal: objs[0].valor * _.sumBy(objs, 'cantidad'),
          }))
          .value();

        this.setState({
          ...this.state,
          envios: output,
        });
      });
    } catch (err) {
      Modal.error({
        title: 'Error en el calculo de los items de los envios',
        content:
          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
      });
      console.log(err);
    }
  };

  onCancelar = () => {
    this.setState({
      ...this.state,
      step: 0,
    });
  };

  cerrarPeriodo = () => {
    let yo = this;
    confirm({
      title: 'Esta seguro que quiere cerrar este periodo?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        //Hacer Algo!.
        yo.armarDatosyEnviar();
      },
      onCancel() {
        console.log('Cancelado');
      },
    });
  };

  armarDatosyEnviar = () => {
    //Armamos los envios:
    let envios = [];
    _.map(this.state.ingresos, envio => {
      let detalles = [];
      _.map(envio.detalle, detalle => {
        detalles.push({
          idTipo_Sello: detalle.tipo_sello._id,
          cantidad: detalle.cantidad,
        });
      });

      envios.push({
        detalle: detalles,
        fechaEnvio: moment(envio.fechaEnvio).toDate(),
        idOrganismoReceptor: envio.receptor._id,
        idOrganismoRemitente: envio.remitente._id,
        importe: envio.importe,
      });
    });

    //Armamos los Depositos.

    let depositos = [];

    _.map(this.state.depositos, deposito => {
      depositos.push({
        importe: deposito.importe,
        fecha: moment(deposito.fecha, 'DD/MM/YYYY').toDate(),
        idOrganismo: deposito.organismo._id,
        idSucursal: deposito.sucursal._id,
        numBoletaDeposito: deposito.numBoletaDeposito,
      });
    });

    //Armamos las ventas en efectivo:

    let montoVentaTotal = 0;
    let detail = [];
    _.map(this.state.tipo_sellos, tipo => {
      detail.push({
        idTipo_Sello: tipo.key,
        nombre: tipo.nombre,
        valor: tipo.valor,
        subTotal: tipo.subTotal,
        cantidad: tipo.cantidad,
      });
      montoVentaTotal += tipo.subtotal;
    });

    let venta = {
      importe: montoVentaTotal,
      idOrganismo: this.props.data.getUsuario.organismo._id,
      detalle: detail,
    };

    //Armamos las ventas en posnet:

    montoVentaTotal = 0;
    detail = [];
    _.map(this.state.detalle_posnet, tipo => {
      detail.push({
        idTipo_Sello: tipo.key,
        nombre: tipo.nombre,
        valor: tipo.valor,
        subTotal: tipo.subTotal,
        cantidad: tipo.cantidad,
      });
      montoVentaTotal += tipo.subtotal;
    });

    let ventasPosnet = {
      importe: montoVentaTotal,
      idOrganismo: this.props.data.getUsuario.organismo._id,
      detalle: detail,
    };

    let obj = {
      fechaInicio: this.state.fechaInicio,
      fechaFin: this.state.fechaFin,
      idUsuarioCreador: this.props.data.getUsuario._id,
      idOrganismo: this.state.idOrganismo,
      depositos: depositos,
      ventasEfectivo: venta,
      ventasPosnet,
      ingresos: envios,
    };

    this.props
      .insertRendicion({
        variables: {
          objRendicion: obj,
        },
      })
      .then(respuesta => {
        if (respuesta.data.insertRendicion) {
          this.props.history.push('/');
        }
      })
      .catch(err => {
        console.log('ERROR AL INSERTAR');
        console.log(err);
      });
  };

  imprimir = () => {
    imprimirReporteRendicion({
      detalle_efectivo: this.state.tipo_sellos,
      detalle_posnet: this.state.detalle_posnet,
      depositos: this.state.depositos,
      envios: this.state.envios,
      fechaGeneracion: moment(this.state.fechaGeneracion).format(
        'DD/MM/YYYY HH:mm'
      ),
      fechaInicio: moment(this.state.fechaInicio).format('DD/MM/YYYY'),
      fechaFin: moment(this.state.fechaFin).format('DD/MM/YYYY'),
      nombreOrganismo: this.state.nombreOrganismo,
    });
  };

  render() {
    const { data } = this.props;
    if (data.loading || (this.state.step == 1 && !this.state.terminado)) {
      return <Loading />;
    }

    // if (!data.getUsuario) {
    //   return null;
    // }
    const { Step } = Steps;
    let { step } = this.state;
    let fGeneracion = moment(this.state.fechaGeneracion).format(
      'DD/MM/YYYY HH:mm'
    );

    let fInicio = moment(this.state.fechaInicio).format('DD/MM/YYYY');
    let fFin = moment(this.state.fechaFin).format('DD/MM/YYYY');

    let montoTotalVentasDelMes = _.sumBy(this.state.tipo_sellos, o => {
      return o.subtotal;
    });
    let montoTotalVentasPosnetDelMes = _.sumBy(this.state.detalle_posnet, o => {
      return o.subtotal;
    });

    let montoTotalDepositos = _.sumBy(this.state.depositos, o => {
      return o.importe;
    });

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Administracion General</Breadcrumb.Item>
          <Breadcrumb.Item>Reportes</Breadcrumb.Item>
          <Breadcrumb.Item>Reportes de Rendicion</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h1 className="tituloForm">Administración General</h1>
          <Steps className="stepsFormularios" current={step}>
            <Step title="Seleccionar Fechas" />
            <Step title="Visualizar Resultados" />
          </Steps>
          {step == 0 && <FormRangoFechas buscar={this.buscar} />}
          {step == 1 && (
            <div>
              <h2 style={{ textAlign: 'center', marginTop: 40 }}>
                Reporte de Rendicion
              </h2>

              <h2 style={{ textAlign: 'center', marginTop: 40 }}>
                Organismo: {this.state.nombreOrganismo}
              </h2>

              <h3 style={{ textAlign: 'center', marginTop: 20 }}>
                Reporte para el rango de fechas de: {fInicio} - {fFin}
              </h3>

              <h5 style={{ textAlign: 'center', marginTop: 20 }}>
                Fecha de generacion: {fGeneracion}
              </h5>

              <br />

              {this.state.ventas_efectivo.length > 0 && (
                <div>
                  {/* Ventas del Periodo de Fechas */}
                  <h3 style={{ textAlign: 'center', marginTop: 20 }}>
                    VENDIDOS EN EFECTIVO DEL: {fInicio} AL {fFin}
                  </h3>
                  <TablaReporteVentas
                    organismo={this.state.nombreOrganismo}
                    fechaInicio={this.state.fechaInicio}
                    fechaFin={this.state.fechaFin}
                    data={this.state.tipo_sellos}
                    onCancelar={this.onCancelar}
                  />
                  <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                    Monto: $ {montoTotalVentasDelMes}
                  </h3>
                </div>
              )}

              {/* Ventas CON POSNET del Periodo de Fechas */}

              {this.state.detalle_posnet.length > 0 && (
                <div>
                  <h3 style={{ textAlign: 'center', marginTop: 20 }}>
                    VENDIDOS CON POSNET DEL: {fInicio} AL {fFin}
                  </h3>
                  <TablaReporteVentas
                    organismo={this.state.nombreOrganismo}
                    fechaInicio={this.state.fechaInicio}
                    fechaFin={this.state.fechaFin}
                    data={this.state.detalle_posnet}
                    onCancelar={this.onCancelar}
                  />
                  <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                    Monto: $ {montoTotalVentasPosnetDelMes}
                  </h3>
                </div>
              )}

              {/* Depositos del Rango de Fecha */}
              <h3 style={{ textAlign: 'center', marginTop: 20 }}>
                DEPOSITOS EFECTUADOS ENTRE LAS FECHAS: {fInicio} - {fFin}
              </h3>
              <TablaMostrarDepositos
                organismo={this.state.nombreOrganismo}
                fechaInicio={this.state.fechaInicio}
                fechaFin={this.state.fechaFin}
                data={this.state.depositos}
                onCancelar={this.onCancelar}
              />
              <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                Monto: $ {montoTotalDepositos}
              </h3>
              <br />
              <br />
              <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                <Button
                  style={{ margin: 5 }}
                  disabled={
                    this.props.data.getUsuario.organismo._id != '00004' &&
                    this.props.usuario.rol != 'SUPERVISOR'
                  }
                  type="primary"
                  onClick={() => this.cerrarPeriodo()}
                >
                  Cerrar Periodo
                </Button>
                <Button style={{ margin: 5 }} onClick={() => this.imprimir()}>
                  Imprimir
                </Button>
              </h3>
            </div>
          )}
        </Layout>
      </div>
    );
  }
}

export default withApollo(ReporteRendicion);
